//import { Conexiones } from "app/conexiones";

export const getInfoUser = () => {
    let infoUser = JSON.parse(localStorage.getItem('infoUser'));
    return infoUser ? infoUser : {};
}

export const getCompanies = () => {
    let companies = JSON.parse(localStorage.getItem('companies'));
    return companies ? companies : [];
}

export const getCompanySelected = () => {
    let companySelected = JSON.parse(localStorage.getItem('companySelected'));
    return companySelected ? companySelected : {};
}

export const getApiCompany = () => {
    let apicompany = localStorage.getItem('apicompany');
    return Number(apicompany);
}

export const getToken = () => {
    let token = localStorage.getItem('token');
    return token ? token : '';
}

export const getTypeConectionApi = () => {
    //let conexion = new Conexiones();
    //conexion.getConexion();

    //return conexion.version;
}/****/